/**
 * Converts a string to lowercase while preserving any uppercase abbreviations.
 *
 * Example:
 * "Hello WORLD from NASA" -> "hello WORLD from NASA"
 */

export const toLowerCaseWithPreservedAbbreviations = (text: string | null | undefined): string => {
    if (!text) return '';

    const abbreviationRegex = /[A-Z]{2,}/dg;

    const abbreviations = text.matchAll(abbreviationRegex) || [];

    let newText = text.toLowerCase().split('');

    abbreviations.forEach((abbr) => {
        const indices = abbr.indices;

        if (indices) {
            const [from, to] = indices[0];

            newText.splice(from, to - from, ...abbr[0].split(''));
        }
    });

    return newText.join('');
};
